import psHttp from '@patsnap/common-ps-http';
import { DRAFTING_URI } from '@/constants/base-url';
import type { WorkMode, DocumentType, StartDraftingRequest, StartDraftingResponse } from './types';

export type QuotaStatus = 'ok' | 'personal_exhausted' | 'company_exhausted'

export interface FeaturePermission {
  enabled: boolean
  quota_status: QuotaStatus
}

export async function addDraftingTrailApi(): Promise<{ success: boolean }> {
    const response = await psHttp<{ success: boolean }>({
        url: `${DRAFTING_URI}/api/user/add-drafting-trial`,
        method: 'POST',
    });
    return response.data;
}

/**
 * 开始撰写任务
 *
 * 创建项目、文档、会话等，返回相关 ID
 */
export async function startDraftingApi(data: StartDraftingRequest): Promise<StartDraftingResponse> {
    const response = await psHttp<StartDraftingResponse>({
        url: `${DRAFTING_URI}/api/home/start`,
        method: 'POST',
        data,
        transformCode: true,
    });
    return response.data;
}

export function getFeaturePermissions(): Promise<{ data: Record<string, FeaturePermission> }> {
    return psHttp({
        url: `${DRAFTING_URI}/api/user/feature_permissions`,
        method: 'GET',
        transformCode: true,
    }).then(({ data }) => ({ data: data.data }))
}
